import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../utils/api';

// Query keys
const HOME_BANNERS_QUERY_KEY = 'homeBanners';

// Custom hook for fetching home banners
export const useHomeBanners = (page = 1, limit = 10) => {
  return useQuery({
    queryKey: [HOME_BANNERS_QUERY_KEY, { page, limit }],
    queryFn: () => apiClient.homeBanners.getAll(page, limit),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Custom hook for fetching single home banner
export const useHomeBanner = (id) => {
  return useQuery({
    queryKey: [HOME_BANNERS_QUERY_KEY, id],
    queryFn: () => apiClient.homeBanners.getById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Custom hook for creating home banner
export const useCreateHomeBanner = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data) => apiClient.homeBanners.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [HOME_BANNERS_QUERY_KEY] });
    },
  });
};

// Custom hook for updating home banner
export const useUpdateHomeBanner = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }) => apiClient.homeBanners.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [HOME_BANNERS_QUERY_KEY] });
    },
  });
};

// Custom hook for deleting home banner
export const useDeleteHomeBanner = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id) => apiClient.homeBanners.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [HOME_BANNERS_QUERY_KEY] });
    },
  });
}; 